import { Button, Flex, Input, InputGroup, Stack, Tag, TagCloseButton, TagLabel } from '@chakra-ui/react';
import { useCallback, useState } from 'react';
import { useKey } from 'react-use';

export const TextFilter = ({
    filterValue,
    setFilterValue,
    inputRef,
}: {
    filterValue?: string[];
    setFilterValue: (value?: string[]) => void;
    inputRef?: React.MutableRefObject<HTMLInputElement | null>;
}) => {
    const [inputValue, setInputValue] = useState('');
    const onAdd = useCallback(() => {
        if (!inputValue) {
            return;
        }

        setFilterValue([...(filterValue || []), inputValue]);
        setInputValue('');
    }, [filterValue, inputValue, setFilterValue]);

    const onRemove = useCallback(
        (value: string) => {
            const filteredValues = filterValue?.filter((v) => v !== value);
            setFilterValue(filteredValues && filteredValues.length > 0 ? filteredValues : undefined);
        },
        [filterValue, setFilterValue],
    );

    useKey(
        'Enter',
        () => {
            document.activeElement === inputRef?.current && onAdd();
        },
        {},
        [onAdd],
    );

    return (
        <Stack>
            <Flex>
                <InputGroup size="sm">
                    <Input
                        borderRightRadius={0}
                        ref={inputRef}
                        variant="outline"
                        value={inputValue}
                        onChange={(ev) => setInputValue(ev.target.value)}
                    />
                </InputGroup>
                <Button variant="outline" size="sm" borderLeftRadius={0} borderLeft={0} onClick={onAdd}>
                    Add
                </Button>
            </Flex>

            {filterValue && (
                <Flex gap={1} flexWrap="wrap">
                    {filterValue.map((value, idx) => (
                        <Tag textTransform="none" key={idx} flexShrink={0} size="sm">
                            <TagLabel>{value}</TagLabel>
                            <TagCloseButton onClick={() => onRemove(value)} />
                        </Tag>
                    ))}
                </Flex>
            )}
        </Stack>
    );
};
